import React, { useEffect, useState } from 'react';
import jsCookie from 'js-cookie';

import { Text, StyledDialog } from '../index';

import {
    StyledPaper,
    StyledDialogContentContainer,
    StyledCookiesCard,
    StyledCookiesContent,
    StyledCookiesButtonContainer,
    StyledButton,
    StyledCookiesDialogButtonContainer,
    StyledCookiesContainer,
} from './style';

const Popup = () => {
    const acceptCookieConsent = () => {
        jsCookie.remove('friday_cookie_consent');
        jsCookie.set('friday_cookie_consent', true, { expires: 30 });

        setAccepted(true);
        setShowDialog(false);
    };

    const [accepted, setAccepted] = useState(true);

    useEffect(() => {
        let cookie_consent = jsCookie.get('friday_cookie_consent');

        if (cookie_consent) {
            setAccepted(true);
        } else {
            setAccepted(false);
        }
    }, []);

    const [showDialog, setShowDialog] = useState(false);

    const handleCloseDialog = () => {
        setShowDialog(false);
    };

    const handleShowDialog = () => {
        setShowDialog(true);
    };

    return (
        !accepted && (
            <StyledCookiesContainer>
                {showDialog ? (
                    <StyledDialog
                        scroll="body"
                        open={showDialog}
                        onClose={handleCloseDialog}
                        aria-labelledby="Cookies Dialog"
                        aria-describedby="Cookies Dialog"
                        PaperComponent={StyledPaper}
                        style={{ zIndex: '100000' }}
                    >
                        <StyledDialogContentContainer>
                            <StyledCookiesContent>
                                <Text
                                    style={{
                                        color: '#0A093D',
                                        fontWeight: 'bold',
                                        fontSize: '18px',
                                    }}
                                >
                                    เว็บไซต์นี้มีการใช้คุกกี้
                                </Text>
                                <Text
                                    style={{
                                        color: '#656464',
                                        fontWeight: '300',
                                        fontSize: '14px',
                                    }}
                                >
                                    เว็บไซต์ของฟราย์เดย์ มีการใช้งานคุกกี้ (Cookies)
                                    เพื่อให้ท่านสามารถเข้าใช้งานในส่วนต่างๆ ของเว็บไซต์
                                    หรือแอปพลิเคชันของฟราย์เดย์ได้ โดยเมื่อท่านทำการกด
                                    “ยอมรับคุกกี้” จะถือว่าท่านได้ตกลงให้ฟราย์เดย์ ใช้คุกกี้
                                    เพื่อที่จะเก็บรวบรวมข้อมูลส่วนตัวของท่าน เพื่อเป็นประโยชน์
                                    และเพิ่มประสิทธิภาพสูงสุดในการเข้ารับดูแลรักษาท่านต่อไป
                                </Text>
                                <Text
                                    style={{
                                        color: '#656464',
                                        fontWeight: '300',
                                        fontSize: '14px',
                                    }}
                                >
                                    ทั้งนี้ ถ้าท่านยังคงใช้งานต่อไปโดยไม่ปฏิเสธคุกกี้ ฟราย์เดย์
                                    จะดำเนินการเก็บคุกกี้เพื่อวัตถุประสงค์ข้างต้น
                                    โดยท่านสามารถศึกษารายละเอียดเกี่ยวกับการใช้คุกกี้ของฟราย์เดย์ได้ที่
                                    นโยบายการใช้คุกกี้ นอกจากนี้
                                    นโยบายการใช้คุกกี้นี้อาจมีการปรับปรุงแก้ไขหรือเปลี่ยนแปลงตามความเหมาะสมเพื่อให้เป็นไปตามกฎหมาย
                                    และกฎระเบียบที่เกี่ยวข้องฟราย์เดย์จึงขอแนะนำให้ท่านตรวจสอบเพื่อให้แน่ใจว่าท่านเข้าใจการเปลี่ยนแปลง
                                    นโยบายดังกล่าว ทั้งนี้
                                    คุณสามารถดูข้อมูลเพิ่มเติมเกี่ยวกับการเก็บรวบรวม ใช้
                                    และเปิดเผยข้อมูลส่วน บุคคลของคุณ
                                    สิทธิต่างๆรวมถึงรายละเอียดเกี่ยวกับผู้ควบคุมข้อมูลส่วนบุคคลได้จากนโยบายการคุ้มครอง
                                    ข้อมูลส่วนบุคคลของฟราย์เดย์ บนเว็บไซต์
                                </Text>
                            </StyledCookiesContent>
                            <StyledCookiesDialogButtonContainer>
                                <StyledButton
                                    style={{ backgroundColor: '#3E44E3', color: 'white' }}
                                    onClick={acceptCookieConsent}
                                >
                                    ยอมรับทั้งหมด
                                </StyledButton>
                                <StyledButton
                                    style={{
                                        backgroundColor: 'rgba(180, 180, 180, 0.2)',
                                        color: '#454A67',
                                    }}
                                    onClick={handleCloseDialog}
                                >
                                    ปิด
                                </StyledButton>
                            </StyledCookiesDialogButtonContainer>
                        </StyledDialogContentContainer>
                    </StyledDialog>
                ) : (
                    <StyledCookiesCard>
                        <StyledCookiesContent>
                            <Text
                                style={{
                                    color: '#0A093D',
                                    fontWeight: 'bold',
                                    fontSize: '18px',
                                }}
                            >
                                เว็บไซต์นี้มีการใช้คุกกี้
                            </Text>
                            <Text style={{ color: '#656464', fontWeight: '300', fontSize: '14px' }}>
                                เว็บไซต์ของฟราย์เดย์ มีการใช้งานคุกกี้ (Cookies)
                                เพื่อให้ท่านสามารถเข้าใช้งานในส่วนต่างๆ ของเว็บไซต์
                                หรือแอปพลิเคชันของฟราย์เดย์ได้ โดยเมื่อท่านทำการกด “ยอมรับคุกกี้”
                                จะถือว่าท่านได้ตกลงให้ฟราย์เดย์ ใช้คุกกี้
                                เพื่อที่จะเก็บรวบรวมข้อมูลส่วนตัวของท่าน เพื่อเป็นประโยชน์
                                และเพิ่มประสิทธิภาพสูงสุดในการเข้ารับดูแลรักษาท่านต่อไป
                            </Text>
                        </StyledCookiesContent>
                        <StyledCookiesButtonContainer>
                            <StyledButton
                                style={{ backgroundColor: '#3E44E3', color: 'white' }}
                                onClick={acceptCookieConsent}
                            >
                                ยอมรับทั้งหมด
                            </StyledButton>
                            <StyledButton
                                style={{
                                    backgroundColor: 'rgba(180, 180, 180, 0.2)',
                                    color: '#454A67',
                                }}
                                onClick={handleShowDialog}
                            >
                                ดูรายละเอียด
                            </StyledButton>
                        </StyledCookiesButtonContainer>
                    </StyledCookiesCard>
                )}
            </StyledCookiesContainer>
        )
    );
};

export default Popup;
